// permissions.js — role helpers. Role comes from the JWT, stored at login.
export const getRole = () => localStorage.getItem('role') || '';
export const isAdmin = () => getRole() === 'admin';
export const isDoctor = () => getRole() === 'doctor';

export default { getRole, isAdmin, isDoctor };
